module.exports = "../content/7384da64612787e3662872e9d19cbc2d.ttf";